// extracted by mini-css-extract-plugin
module.exports = {"search":"ef","light":"eg","primary":"eh","searchTitle":"ei","searchPanel":"ej","searchPanelRow":"ek","searchButton":"el"};